const { bootstrapButtonStyleClasses } = require('@isoftdata/utility-bootstrap')
const { splitArray } = require('@isoftdata/utility-array')

module.exports = function createButtonComponent() {
	return Ractive.extend({
		template: require('./index.html'),
		data() {
			return {
				class: '',
				id: '',
				textClass: null,
				style: null,
				bootstrapButtonSizeClass: null,
				iconClass: null,
				iconColor: null,
				iconStyle: null,
				disabled: false,
				type: 'button',
				colorGreyDisabled: true,
				download: false,
				href: '',
				target: '',
				hasTextAndIcon: false,
			}
		},
		attributes: {
			required: [ ],
			optional: [
				'class',
				'id',
				'textClass',
				'style',
				'bootstrapButtonSizeClass',
				'iconClass',
				'iconColor',
				'iconStyle',
				'disabled',
				'type',
				'colorGreyDisabled',
				'download',
				'href',
				'target',
			],
		},
		computed: {
			computedClass() {
				const givenClasses = this.get('class').split(' ')

				const {
					fail: bootstrapButtonClass,
					pass: classes,
				} = splitArray({
					array: givenClasses,
					test: theClass => !bootstrapButtonStyleClasses.includes(theClass),
				})

				if (this.get('disabled')) {
					classes.push('disabled')
				}

				if (this.get('disabled') && this.get('colorGreyDisabled')) {
					classes.push('btn-secondary')
				} else if (bootstrapButtonClass.length > 0) {
					classes.push(bootstrapButtonClass[0])
				} else {
					classes.push(bootstrapButtonStyleClasses[0])
				}

				return classes.join(' ')
			},
		},
		onrender() {
			const ractive = this

			function buttonHasTextAndIcon() {
				const buttonText = ractive.find('#buttonText').innerHTML
				ractive.set({ hasTextAndIcon: !!(ractive.get('iconClass') && buttonText) })
			}

			const buttonTextEl = ractive.find('#buttonText')

			if (buttonTextEl) {
				const observer = new MutationObserver(buttonHasTextAndIcon)
				observer.observe(buttonTextEl, { subtree: true, childList: true })
			}

			ractive.observe('iconClass', () => buttonHasTextAndIcon())
		},
	})
}
